/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Optimization method enum
 */
export enum OptimizationMethod {

    GridSearch = 'GridSearch',

    RandomSearch = 'RandomSearch',

    Bayesian = 'Bayesian',

    GeneticAlgorithm = 'GeneticAlgorithm',

    ParticleSwarm = 'ParticleSwarm'
}
